import clsx from 'clsx'
import Link from 'next/link'
import { FC } from 'react'

import { BankData } from '@/screens/Credit/page/types'

import cl from './ConditionsNotation.module.scss'

const ConditionsNotation: FC<{ item: BankData }> = ({ item }) => {
	return (
		<div className={cl.conditions__notationWrapper}>
			{item.availableDevices === 'all' && (
				<>
					<p className={cl.conditions__notationTitle}>
						Кредиты доступны на{' '}
						<Link prefetch={false} href={'/catalog'}>
							весь ассортимент
						</Link>
					</p>
				</>
			)}
			{Array.isArray(item.availableDevices) && item.availableDevices.length > 0 && (
				<>
					<p className={cl.conditions__notationTitle}>Устройства доступные в рассрочку</p>
					<ul className={clsx(cl.conditions__notationList, cl.conditions__notationList_full)}>
						{item.availableDevices.map((device, deviceIndex) => (
							<li className={cl.conditions__notationItem} key={deviceIndex}>
								{
									<Link prefetch={false} href={device.link} className={cl.conditions__notationLink}>
										{device.label}
									</Link>
								}
							</li>
						))}
					</ul>
				</>
			)}
		</div>
	)
}

export default ConditionsNotation
